<div class="hero">
  <div class="hero-overlay"></div>
  <div class="hero-content d-flex">
    <div class="container-lg d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-center justify-content-md-start gap-2 gap-sm-3 gap-md-4 gap-xxl-5 gx-xxl-5">

      <!-- spacing helper -->
      <div class="logo-spacer"></div>

      <div class="top-banner-logo">
        <img
          class="top-banner-logo-purple"
          src="assets/images/petsChip/catsprotectionwhite-logo.png"
          alt="catsprotectionwhite-logo"
        />
      </div>
      <div class="hero-content-text">
        <h6 class="mb-0">
          identi and Cats Protection are working together to help keepers find out which microchip database
          stores their pet’s details and whether they are up to date.
        </h6>
      </div>

    </div>
  </div>
</div>

<div class="check-container container">
  <div class="title-container my-2 mx-4">
    <h2 class="pets-chip-title fw-bold">How to check your pet's chip</h2>
  </div>
</div>

<app-locate-microchip-step
  [ngClass]="'app-locate-microchip-step-left'"
  [positioning]="'left'"
  [title]="'Enter the chip number below'"
  [text]="'Once you have located your pet`s chip number, you can enter it into the box below. Our handy tool will search through all Defra approved UK databases and find where your pet is registered.'"
  [dataBeforeContent]="'1'"
></app-locate-microchip-step>

<div class="check-container container pt-3">
  <div class="row">
    <div class="col-12 col-md-6 d-flex flex-column">
      <app-chip-checker class="mb-3" [variant]="'check-pet'"></app-chip-checker>
    </div>
    <div class="col-12 col-md-6 check-container-right">
      <h4 class="mt-3">Why check your pet’s microchip?</h4>
      <ul class="list-content">
        <li>A microchip is the best way to help reunite you with your pet</li>
        <li>A microchip is only as good as the data stored on it</li>
        <li>Keepers risk a £500 fine if their information is out of date</li>
        <li>Knowing your pet’s database saves time if your pet gets lost or stolen</li>
      </ul>
    </div>
  </div>
</div>

<app-locate-microchip-step
  [ngClass]="'app-locate-microchip-step-right'"
  [positioning]="'right'"
  [dataBeforeContent]="'2'"
  title="What next?"
  text="There are a few different actions you should take depending on the outcome of checking your pet's chip. See the orange boxes below for more details."
></app-locate-microchip-step>

<div class="next-check-container pb-4">
  <div class="check-container container mt-4">
    <h2 class="pets-chip-title mb-5 mt-4 fw-bold">Next Steps</h2>
    <p class="h5">
      Depending on where your pet is registered or if they aren't registered, here's how you can
      reach your pet's microchip record:
    </p>
    <div class="cards-container mx-3 mb-3">
      <app-next-step-card
        *ngFor="let cardProps of nextStepCards"
        class="card"
        [title]="cardProps.title"
        [text]="cardProps.text"
        [secondaryText]="cardProps.secondaryText"
        [link]="cardProps.link"
        [linkRedirect]="cardProps.linkRedirect"
        [button]="cardProps.button"
        [variant]="'next-purina'"
      ></app-next-step-card>
    </div>
  </div>
</div>

<div class="next-check-container pb-4">
  <div class="check-container container mt-4">
    <h2 class="pets-chip-title mb-5 mt-4 fw-bold text-center">Microchips in action</h2>
  </div>
</div>

<div class="footer-picture">
  <div class="footer-button">
    <div class="footer-button-container">
      <button type="button" class="btn btn-white footer-button-container-button" (click)="redirectToZendesk()">
        <span class="footer-button-container-button-text">Find out more</span>
      </button>
    </div>
  </div>
  <img class="footer-picture-image" src="assets/images/petsChip/check-chip-footer.png" alt="check-chip-footer" />
</div>
